import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=eeb4d966&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=eeb4d966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb4d966",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeb4d966')) {
      api.createRecord('eeb4d966', component.options)
    } else {
      api.reload('eeb4d966', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=eeb4d966&scoped=true&", function () {
      api.rerender('eeb4d966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/comp/PopupBox.vue"
export default component.exports